module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactionlist"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar', {
    attrs: {
      "fatherMethod": _vm.initialize
    }
  }), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("交易列表")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("交易搜索")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.searchlist.sku_title),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "sku_title", $$v)
      },
      expression: "searchlist.sku_title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入订单号"
    },
    model: {
      value: (_vm.searchlist.trade_id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "trade_id", $$v)
      },
      expression: "searchlist.trade_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("收件人姓名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入收件人姓名"
    },
    model: {
      value: (_vm.searchlist.receiver_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "receiver_name", $$v)
      },
      expression: "searchlist.receiver_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("收件人手机号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入收件人手机号"
    },
    model: {
      value: (_vm.searchlist.receiver_phone),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "receiver_phone", $$v)
      },
      expression: "searchlist.receiver_phone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('a-range-picker', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "defaultValue": (!_vm.searchlist.start_time && !_vm.searchlist.end_time) ? null : [_vm.moment(_vm.searchlist.start_time, _vm.dateFormat), _vm.moment(_vm.searchlist.end_time, _vm.dateFormat)]
    },
    on: {
      "change": _vm.onChangeTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("会员ID")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入会员ID"
    },
    model: {
      value: (_vm.searchlist.user_id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "user_id", $$v)
      },
      expression: "searchlist.user_id"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("商品通道")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchlist.product_channel),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "product_channel", $$v)
      },
      expression: "searchlist.product_channel"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("全部产品")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("大宗贸易")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("保税备货")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("澳洲直邮")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("国货严选")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("买家昵称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入买家昵称"
    },
    model: {
      value: (_vm.searchlist.nick_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "nick_name", $$v)
      },
      expression: "searchlist.nick_name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-container"
  }, [_c('a-tabs', {
    attrs: {
      "defaultActiveKey": _vm.liststatus,
      "activeKey": _vm.liststatus,
      "type": "card",
      "tabBarGutter": 5
    },
    on: {
      "change": _vm.tabChange
    }
  }, [_c('a-tab-pane', {
    key: "all",
    attrs: {
      "tab": "全部"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("状态")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        },
        attrs: {
          "span": 6
        }
      }, [_vm._v(_vm._s(_vm.status[order.order_status]))])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [(item.status != 'closed' && item.status != 'finished' && item.status != 'success') ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_address_btn(item)
        }
      }
    }, [_vm._v("修改地址")]) : _vm._e(), _vm._v(" "), (item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), ((item.first_agency_id || item.second_agency_id) && !(item.profitsharing_info || item.profitsharing_fail_info)) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("该订单含有代理分账：")]), _vm._v(" "), _c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingquery(item)
        }
      }
    }, [_vm._v("查询")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info || item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t分账状态提交记录：" + _vm._s(item.is_clear ? '已提交' : '未提交') + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_first_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_second_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 18
      }
    }, [_c('span', [_vm._v(_vm._s(item.profitsharing_fail_info))])]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingfinish(item)
        }
      }
    }, [_vm._v("尝试完结分账")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t实际分账信息：" + _vm._s(item.profitsharing_info.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.profitsharing_info.receivers), function(receivers, receiversindex) {
      return _c('a-col', {
        key: receiversindex,
        attrs: {
          "span": 8
        }
      }, [(receivers.type == 'MERCHANT_ID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(receivers.description) + ",金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (receivers.type == 'PERSONAL_OPENID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t账户:" + _vm._s(receivers.user_id) + ",实际分账金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
    })], 2) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "to_be_paid",
    attrs: {
      "tab": "待付款"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order, order_index) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [(item.hb_number > 0) ? _c('a-button', {
        staticStyle: {
          "width": "128px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "disabled": "",
          "size": "small",
          "type": "primary"
        }
      }, [_vm._v("花呗订单无法改价")]) : _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.modify_price_btn(item, order)
          }
        }
      }, [_vm._v("修改价格")]), _vm._v(" "), (order_index == 0) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px",
          "margin-top": "10px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.cancelbtn(order, 1)
          }
        }
      }, [_vm._v("整单取消")]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_address_btn(item)
        }
      }
    }, [_vm._v("修改地址")]), _vm._v(" "), (item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1)], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "have_paid",
    attrs: {
      "tab": "待发货"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "margin-right": "15px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    attrs: {
      "type": "primary",
      "disabled": true
    },
    on: {
      "click": _vm.daoru
    }
  }, [_vm._v("导入物流单号")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order, order_index) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 1
        }
      }), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [(order.order_status == 'have_paid') ? _c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(!order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.refund_btn(order, item)
          }
        }
      }, [_vm._v("退款")]) : _vm._e(), _c('br'), _vm._v(" "), (order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small",
          "disabled": true
        }
      }, [_vm._v("订单退款中......")]) : _vm._e(), (order.is_refund) ? _c('br') : _vm._e(), _vm._v(" "), (item.is_match_trade && order_index == 0) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.cancelbtn(order, 1)
          }
        }
      }, [_vm._v("整单取消")]) : _vm._e(), _vm._v(" "), (!item.is_match_trade) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.cancelbtn(order, 0)
          }
        }
      }, [_vm._v("取消订单")]) : _vm._e()], 1) : (order.order_status == 'refund') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("退款售后")]) : (order.order_status == 'closed') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("已取消")]) : (order.order_status == 'delivery') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("物流已发出")]) : _vm._e()])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_address_btn(item)
        }
      }
    }, [_vm._v("修改地址")]), _vm._v(" "), (item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), _vm._l((item.TC_Delivery_Infos), function(express, ind) {
      return _c('div', {
        key: ind
      }, [_c('a-row', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("物流公司：" + _vm._s(express.express_display))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("快递单号：" + _vm._s(express.express_number))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 9
        }
      }, [_vm._v("备注信息：" + _vm._s(express.remarks))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.modify_express_number_btn(item, express)
          }
        }
      }, [_vm._v("修改单号")]), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.query_express_btn(express, true)
          }
        }
      }, [_vm._v("查询物流")])], 1)], 1), _vm._v(" "), _c('a-row', {
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [(express.query && express.delivery_info && express.delivery_info.nu) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_c('a-steps', {
        attrs: {
          "direction": "vertical",
          "size": "small",
          "progressDot": ""
        }
      }, _vm._l((express.delivery_info.data), function(info, index) {
        return _c('a-step', {
          key: index,
          attrs: {
            "status": "process",
            "title": info.time,
            "description": info.context
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (express.query && (!express.delivery_info || !express.delivery_info.nu)) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("暂无信息")]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "margin-bottom": "5px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.express_btn(item, item.receiver_phone, item.id_card_id)
        }
      }
    }, [_vm._v("发货")])], 1)], 1)], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "delivery",
    attrs: {
      "tab": "已发货"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 1
        }
      }), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [(order.order_status == 'delivery') ? _c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(!order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.refund_btn(order, item)
          }
        }
      }, [_vm._v("退款")]) : _vm._e(), _c('br'), _vm._v(" "), (order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small",
          "disabled": true
        }
      }, [_vm._v("订单退款中......")]) : _vm._e(), (order.is_refund) ? _c('br') : _vm._e()], 1) : (order.order_status == 'refund') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("退款售后")]) : (order.order_status == 'closed') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("已取消")]) : _vm._e()])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_address_btn(item)
        }
      }
    }, [_vm._v("修改地址")]), _vm._v(" "), (item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), _vm._l((item.TC_Delivery_Infos), function(express, ind) {
      return _c('div', {
        key: ind
      }, [_c('a-row', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("物流公司：" + _vm._s(express.express_display))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("快递单号：" + _vm._s(express.express_number))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 9
        }
      }, [_vm._v("备注信息：" + _vm._s(express.remarks))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.modify_express_number_btn(item, express)
          }
        }
      }, [_vm._v("修改单号")]), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.query_express_btn(express, true)
          }
        }
      }, [_vm._v("查询物流")])], 1)], 1), _vm._v(" "), _c('a-row', {
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [(express.query && express.delivery_info && express.delivery_info.nu) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_c('a-steps', {
        attrs: {
          "direction": "vertical",
          "size": "small",
          "progressDot": ""
        }
      }, _vm._l((express.delivery_info.data), function(info, index) {
        return _c('a-step', {
          key: index,
          attrs: {
            "status": "process",
            "title": info.time,
            "description": info.context
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (express.query && (!express.delivery_info || !express.delivery_info.nu)) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("暂无信息")]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "margin-bottom": "5px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.express_btn(item, item.receiver_phone, item.id_card_id)
        }
      }
    }, [_vm._v("发货")])], 1)], 1)], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "finished",
    attrs: {
      "tab": "已完成"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("状态")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 1
        }
      }), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [(order.order_status == 'finished') ? _c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(!order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.refund_btn(order, item)
          }
        }
      }, [_vm._v("退款")]) : _vm._e(), _c('br'), _vm._v(" "), (order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small",
          "disabled": true
        }
      }, [_vm._v("订单退款中......")]) : _vm._e(), (order.is_refund) ? _c('br') : _vm._e()], 1) : (order.order_status == 'refund') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("退款售后")]) : (order.order_status == 'closed') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("已取消")]) : (order.order_status == 'success') ? _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("交易成功")]) : _vm._e()])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [(item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), _vm._l((item.TC_Delivery_Infos), function(express, ind) {
      return _c('div', {
        key: ind
      }, [_c('a-row', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("物流公司：" + _vm._s(express.express_display))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("快递单号：" + _vm._s(express.express_number))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 9
        }
      }, [_vm._v("备注信息：" + _vm._s(express.remarks))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.modify_express_number_btn(item, express)
          }
        }
      }, [_vm._v("修改单号")]), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.query_express_btn(express, false)
          }
        }
      }, [_vm._v("查询物流")])], 1)], 1), _vm._v(" "), _c('a-row', {
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [(express.query && express.delivery_info && express.delivery_info.nu) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_c('a-steps', {
        attrs: {
          "direction": "vertical",
          "size": "small",
          "progressDot": ""
        }
      }, _vm._l((express.delivery_info.data), function(info, index) {
        return _c('a-step', {
          key: index,
          attrs: {
            "status": "process",
            "title": info.time,
            "description": info.context
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (express.query && (!express.delivery_info || !express.delivery_info.nu)) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("暂无信息")]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "margin-bottom": "5px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.express_btn(item, item.receiver_phone, item.id_card_id)
        }
      }
    }, [_vm._v("发货")])], 1)], 1), _vm._v(" "), ((item.first_agency_id || item.second_agency_id) && !(item.profitsharing_info || item.profitsharing_fail_info)) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("该订单含有代理分账：")]), _vm._v(" "), _c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingquery(item)
        }
      }
    }, [_vm._v("查询")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info || item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t分账状态提交记录：" + _vm._s(item.is_clear ? '已提交' : '未提交') + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_first_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_second_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 18
      }
    }, [_c('span', [_vm._v(_vm._s(item.profitsharing_fail_info))])]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingfinish(item)
        }
      }
    }, [_vm._v("尝试完结分账")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t实际分账信息：" + _vm._s(item.profitsharing_info.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.profitsharing_info.receivers), function(receivers, receiversindex) {
      return _c('a-col', {
        key: receiversindex,
        attrs: {
          "span": 8
        }
      }, [(receivers.type == 'MERCHANT_ID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(receivers.description) + ",金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (receivers.type == 'PERSONAL_OPENID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t账户:" + _vm._s(receivers.user_id) + ",实际分账金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
    })], 2) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "success",
    attrs: {
      "tab": "交易成功"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [(item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), _vm._l((item.TC_Delivery_Infos), function(express, ind) {
      return _c('div', {
        key: ind
      }, [_c('a-row', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("物流公司：" + _vm._s(express.express_display))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("快递单号：" + _vm._s(express.express_number))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 9
        }
      }, [_vm._v("备注信息：" + _vm._s(express.remarks))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.modify_express_number_btn(item, express)
          }
        }
      }, [_vm._v("修改单号")]), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.query_express_btn(express, false)
          }
        }
      }, [_vm._v("查询物流")])], 1)], 1), _vm._v(" "), _c('a-row', {
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [(express.query && express.delivery_info && express.delivery_info.nu) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_c('a-steps', {
        attrs: {
          "direction": "vertical",
          "size": "small",
          "progressDot": ""
        }
      }, _vm._l((express.delivery_info.data), function(info, index) {
        return _c('a-step', {
          key: index,
          attrs: {
            "status": "process",
            "title": info.time,
            "description": info.context
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (express.query && (!express.delivery_info || !express.delivery_info.nu)) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("暂无信息")]) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "margin-bottom": "5px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.express_btn(item, item.receiver_phone, item.id_card_id)
        }
      }
    }, [_vm._v("发货")])], 1)], 1), _vm._v(" "), ((item.first_agency_id || item.second_agency_id) && !(item.profitsharing_info || item.profitsharing_fail_info)) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("该订单含有代理分账：")]), _vm._v(" "), _c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingquery(item)
        }
      }
    }, [_vm._v("查询")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info || item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t分账状态提交记录：" + _vm._s(item.is_clear ? '已提交' : '未提交') + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_first_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理分账信息：\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.get_second_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 18
      }
    }, [_c('span', [_vm._v(_vm._s(item.profitsharing_fail_info))])]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingfinish(item)
        }
      }
    }, [_vm._v("尝试完结分账")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t实际分账信息：" + _vm._s(item.profitsharing_info.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.profitsharing_info.receivers), function(receivers, receiversindex) {
      return _c('a-col', {
        key: receiversindex,
        attrs: {
          "span": 8
        }
      }, [(receivers.type == 'MERCHANT_ID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(receivers.description) + ",金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (receivers.type == 'PERSONAL_OPENID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t账户:" + _vm._s(receivers.user_id) + ",实际分账金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
    })], 2) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "refund",
    attrs: {
      "tab": "申请退款售后"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 1
        }
      }), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [(order.order_status == 'refund') ? _c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(!order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.refund_btn(order, item)
          }
        }
      }, [_vm._v("退款")]) : _vm._e(), _c('br'), _vm._v(" "), (order.is_refund) ? _c('a-button', {
        staticStyle: {
          "width": "96px",
          "margin-bottom": "5px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small",
          "disabled": true
        }
      }, [_vm._v("订单退款中......")]) : _vm._e(), (order.is_refund) ? _c('br') : _vm._e(), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px",
          "color": "#ffc300",
          "border-color": "#ffc300"
        },
        attrs: {
          "ghost": "",
          "type": "danger",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.reject_refund_btn(order)
          }
        }
      }, [_vm._v("驳回退款")])], 1) : _c('div', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        }
      }, [_vm._v("退款售后中")])])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [(item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1), _vm._v(" "), _vm._l((item.TC_Delivery_Infos), function(express, ind) {
      return _c('div', {
        key: ind
      }, [_c('a-row', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("物流公司：" + _vm._s(express.express_display))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v("快递单号：" + _vm._s(express.express_number))]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 9
        }
      }, [_vm._v("备注信息：" + _vm._s(express.remarks))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 5
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "ghost": "",
          "size": "small",
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.query_express_btn(express, true)
          }
        }
      }, [_vm._v("查询物流")])], 1)], 1), _vm._v(" "), _c('a-row', {
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [(express.query && express.delivery_info && express.delivery_info.nu) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_c('a-steps', {
        attrs: {
          "direction": "vertical",
          "size": "small",
          "progressDot": ""
        }
      }, _vm._l((express.delivery_info.data), function(info, index) {
        return _c('a-step', {
          key: index,
          attrs: {
            "status": "process",
            "title": info.time,
            "description": info.context
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (express.query && (!express.delivery_info || !express.delivery_info.nu)) ? _c('a-col', {
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("暂无信息")]) : _vm._e()], 1)], 1)
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "closed",
    attrs: {
      "tab": "已取消"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative",
      "margin-bottom": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.tradelist.length
    },
    on: {
      "click": _vm.exportexcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.link_to
    }
  }, [_vm._v("编辑发货短信模板")])], 1), _vm._v(" "), _c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [(item.is_cainiao) ? _c('a-tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("当日达")]) : _vm._e(), _vm._v("订单号：" + _vm._s(item.trade_number) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 3) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：支付宝")]) : _vm._e()], 1), _vm._v(" "), (item.is_match_trade) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("该订单为搭配商品购买订单，请注意退款及取消订单相关操作")])], 1) : _vm._e(), _vm._v(" "), (item.coupon_derate_fee) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px",
        "border-top": "0px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券类型：全店优惠券")]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("券名称：" + _vm._s(item.coupon_card_title))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("优惠券面额：￥" + _vm._s(item.coupon_derate_fee / 100))])], 1) : _vm._e(), _vm._v(" "), _vm._l((item.ali_voucher_detail_list), function(ali_voucher, ali_voucher_index) {
      return (item.ali_voucher_detail_list.length > 0) ? _c('a-row', {
        key: ali_voucher_index,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "height": "30px",
          "line-height": "30px",
          "border-top": "0px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券类型：" + _vm._s(_vm.voucher_type(ali_voucher.type)))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("券名称：￥" + _vm._s(ali_voucher.name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 8
        }
      }, [_vm._v("优惠券面额：￥" + _vm._s(ali_voucher.amount))])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))]), _c('br'), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v("接龙订单")]) : _vm._e(), _vm._v(" "), (item.is_solitaire) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(_vm.solitaireStatus(item)))]) : _vm._e()], 1)]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(order.is_match_order) ? _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("搭配商品")]) : _vm._e(), (order.is_match_order) ? _c('br') : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v(" "), (order.coupon_derate_fee) ? _c('span', [_vm._v("商品优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100))]) : _vm._e()])])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "dashed",
        "shape": "circle-outline",
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          return _vm.copyaddress(item)
        }
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [(item.id_card_id) ? _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.changeidcard(item)
        }
      }
    }, [_vm._v("身份证信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 19
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("运营备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.business_remarks))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.modify_business_remarks_btn(item)
        }
      }
    }, [_vm._v("修改运营备注")])], 1)], 1)], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])], 1)], 1)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "编辑身份证",
      "width": 1000,
      "visible": _vm.id_card_visible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.id_card_Ok,
      "cancel": _vm.id_card_Cancel
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "50%",
      "display": "inline-block"
    },
    attrs: {
      "id": "idimg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right"
    }
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.id_card_info.real_name),
      callback: function($$v) {
        _vm.$set(_vm.id_card_info, "real_name", $$v)
      },
      expression: "id_card_info.real_name"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right"
    }
  }, [_vm._v("身份证号:")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.id_card_info.id_card),
      callback: function($$v) {
        _vm.$set(_vm.id_card_info, "id_card", $$v)
      },
      expression: "id_card_info.id_card"
    }
  })], 1)])]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "发货",
      "width": 600,
      "visible": _vm.express_visible,
      "confirmLoading": _vm.expressLoading
    },
    on: {
      "ok": _vm.express_Ok,
      "cancel": _vm.express_Cancel
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入电话号码"
    },
    on: {
      "change": _vm.phone_number_change
    },
    model: {
      value: (_vm.express_info.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "phone_number", $$v)
      },
      expression: "express_info.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("物流公司")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "showSearch": "",
      "filterOption": _vm.filterOption,
      "value": _vm.express_info.express_name,
      "placeholder": "请选择物流公司"
    },
    on: {
      "change": _vm.expressChange
    }
  }, _vm._l((_vm.express_data), function(item) {
    return _c('a-select-option', {
      key: item.express_display,
      attrs: {
        "value": item.express_name
      }
    }, [_vm._v(_vm._s(item.express_display))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("物流单号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入物流单号"
    },
    on: {
      "change": _vm.express_number_change
    },
    model: {
      value: (_vm.express_info.express_number),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "express_number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "express_info.express_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.express_info.remarks),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "remarks", $$v)
      },
      expression: "express_info.remarks"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("包裹中货物")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "mode": "multiple"
    },
    on: {
      "change": _vm.order_list_change
    },
    model: {
      value: (_vm.express_info.order_list),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "order_list", $$v)
      },
      expression: "express_info.order_list"
    }
  }, _vm._l((_vm.temp_order_list), function(order) {
    return _c('a-select-option', {
      key: order.id
    }, [(order.order_status == 'delivery') ? _c('a-icon', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "type": "check-circle"
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(order.sku_title) + "\n\t\t\t\t\t")], 1)
  }), 1)], 1), _vm._v(" "), (_vm.express_info.id_card_id) ? _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "80px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("同步身份证选项")]), _vm._v(" "), _c('a-checkbox-group', {
    staticStyle: {
      "width": "250px"
    },
    on: {
      "change": _vm.onChangeIdCard
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-checkbox', {
    attrs: {
      "value": "ewe"
    }
  }, [_vm._v("EWE")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "60px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("发送物流跟踪短信")]), _vm._v(" "), _c('a-switch', {
    staticStyle: {
      "margin-right": "20px"
    },
    model: {
      value: (_vm.express_info.send_express_massage),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "send_express_massage", $$v)
      },
      expression: "express_info.send_express_massage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "margin-left": "60px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("发送发货通知短信")]), _vm._v(" "), _c('a-switch', {
    staticStyle: {
      "margin-right": "20px"
    },
    model: {
      value: (_vm.express_info.send_massage),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "send_massage", $$v)
      },
      expression: "express_info.send_massage"
    }
  }), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "value": _vm.express_info.massage_id,
      "placeholder": "请选择短信模板",
      "disabled": !_vm.express_info.send_massage
    },
    on: {
      "change": _vm.note_change
    }
  }, _vm._l((_vm.notetemplatelist), function(note) {
    return _c('a-select-option', {
      key: note.id,
      attrs: {
        "value": note.id
      }
    }, [_vm._v(_vm._s(note.note_title))])
  }), 1)], 1), _vm._v(" "), (_vm.express_info.send_massage) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('a-input', {
    attrs: {
      "type": "textarea",
      "rows": "4",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.express_info.massage_info),
      callback: function($$v) {
        _vm.$set(_vm.express_info, "massage_info", $$v)
      },
      expression: "express_info.massage_info"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "退款",
      "visible": _vm.refund_visible,
      "confirmLoading": _vm.refundLoading
    },
    on: {
      "ok": _vm.refund_Ok,
      "cancel": _vm.refund_Cancel
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("可退金额")]), _vm._v(" "), _c('a-input-number', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "formatter": function (value) { return ("￥ " + value).replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      "parser": function (value) { return value.replace(/\$\s?|(,*)/g, ''); },
      "disabled": ""
    },
    model: {
      value: (_vm.refund_info.can_be_refund_fee),
      callback: function($$v) {
        _vm.$set(_vm.refund_info, "can_be_refund_fee", $$v)
      },
      expression: "refund_info.can_be_refund_fee"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("退款金额")]), _vm._v(" "), _c('a-input-number', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "max": _vm.refund_info.can_be_refund_fee,
      "min": 0,
      "formatter": function (value) { return ("￥ " + value).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    },
    model: {
      value: (_vm.refund_info.refund_fee),
      callback: function($$v) {
        _vm.$set(_vm.refund_info, "refund_fee", $$v)
      },
      expression: "refund_info.refund_fee"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("退款理由")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入退款理由"
    },
    model: {
      value: (_vm.refund_info.remark),
      callback: function($$v) {
        _vm.$set(_vm.refund_info, "remark", $$v)
      },
      expression: "refund_info.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否有退货")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "有",
      "unCheckedChildren": "无"
    },
    model: {
      value: (_vm.refund_info.have_express),
      callback: function($$v) {
        _vm.$set(_vm.refund_info, "have_express", $$v)
      },
      expression: "refund_info.have_express"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("提交api退款")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.refund_info.auto_refund),
      callback: function($$v) {
        _vm.$set(_vm.refund_info, "auto_refund", $$v)
      },
      expression: "refund_info.auto_refund"
    }
  })], 1)])]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "修改地址",
      "visible": _vm.address_visible,
      "confirmLoading": _vm.addressLoading
    },
    on: {
      "ok": _vm.address_Ok,
      "cancel": _vm.address_Cancel
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("收件人姓名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入收件人姓名"
    },
    model: {
      value: (_vm.address_info.receiver_name),
      callback: function($$v) {
        _vm.$set(_vm.address_info, "receiver_name", $$v)
      },
      expression: "address_info.receiver_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("收件人手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入收件人手机号码"
    },
    model: {
      value: (_vm.address_info.receiver_phone),
      callback: function($$v) {
        _vm.$set(_vm.address_info, "receiver_phone", $$v)
      },
      expression: "address_info.receiver_phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("收件人地址")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入收件人地址"
    },
    model: {
      value: (_vm.address_info.receiver_address),
      callback: function($$v) {
        _vm.$set(_vm.address_info, "receiver_address", $$v)
      },
      expression: "address_info.receiver_address"
    }
  })], 1)])]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "修改价格",
      "visible": _vm.price_visible,
      "confirmLoading": _vm.priceLoading
    },
    on: {
      "ok": _vm.price_Ok,
      "cancel": _vm.price_Cancel
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("商品单价")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入商品单价"
    },
    on: {
      "change": _vm.modify_sku_price
    },
    model: {
      value: (_vm.modify_price.order_sku_price),
      callback: function($$v) {
        _vm.$set(_vm.modify_price, "order_sku_price", $$v)
      },
      expression: "modify_price.order_sku_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("商品总价")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入商品总价"
    },
    model: {
      value: (_vm.modify_price.order_receipt_price),
      callback: function($$v) {
        _vm.$set(_vm.modify_price, "order_receipt_price", $$v)
      },
      expression: "modify_price.order_receipt_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("修改备注")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入修改备注"
    },
    model: {
      value: (_vm.modify_price.remarks),
      callback: function($$v) {
        _vm.$set(_vm.modify_price, "remarks", $$v)
      },
      expression: "modify_price.remarks"
    }
  })], 1)])]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "修改运营备注",
      "visible": _vm.business_remarks_visible,
      "confirmLoading": _vm.businessRemarksLoading
    },
    on: {
      "ok": _vm.business_remarks_Ok,
      "cancel": _vm.business_remarks_Cancel
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": "4",
      "placeholder": "请输入运营备注"
    },
    model: {
      value: (_vm.business_remarks.business_remarks),
      callback: function($$v) {
        _vm.$set(_vm.business_remarks, "business_remarks", $$v)
      },
      expression: "business_remarks.business_remarks"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-870b38e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/ordermanagement/transactionlist/index.vue
// module id = 2394
// module chunks = 1